import service from './service';
import { trimString } from '../utils/common';

export default {
  // 获取用户在线聊未读信息
  getUnreadCount(params) {
    params = trimString(params)
    return service.get(`/api/v1/lc/unread-count`, { params });
  },
  // 检查用户是否在线
  checkOnlineStatus(data) {
    return service.post(`/api/v1/lc/check-user-online`, data);
  }
};



// WEBPACK FOOTER //
// ./src/api/realtime.js